(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pd-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerSearchMobile = this.querySelector('.header-search-mobile');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerTop = this.querySelector('.header');
      this.tabbedNav = document.querySelector('.tabbed-navigation-section');
      this.primaryHeader = document.querySelector('.header-primary-nav');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-top-height', `${this.headerTop.offsetHeight}px`);
      document.documentElement.style.setProperty('--mobile-header-height', `${this.header.offsetHeight - this.headerSearchMobile.offsetHeight}px`);
      document.documentElement.style.setProperty('--announcementbar-height', `${this.announcementBar != null ? this.announcementBar.offsetHeight : 0}px`);
      document.documentElement.style.setProperty('--tabbed-nav-height', `0px`);
      document.documentElement.style.setProperty('--header-primary-height', `${this.primaryHeader.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.tabbedNav.classList.add('tabbed-navigation-section-hidden', 'tabbed-navigation-section-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();

      if (screen.width > 750) {
        const facetsContainer = document.querySelector('.section-main-collection .facets-container') 
          || document.querySelector('.template-search .facets-container');
        
        if (facetsContainer) {
          facetsContainer.classList.remove('extra-top');
        }
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.tabbedNav.classList.add('tabbed-navigation-section-sticky');
      this.tabbedNav.classList.remove('tabbed-navigation-section-hidden');

      if (screen.width > 750) {
        const facetsContainer = document.querySelector('.section-main-collection .facets-container')
          || document.querySelector('.template-search .facets-container');
        
        if (facetsContainer) {
          facetsContainer.classList.add('extra-top');
        }
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.tabbedNav.classList.remove('tabbed-navigation-section-hidden', 'tabbed-navigation-section-sticky');

      if (screen.width > 750) {
        const facetsContainer = document.querySelector('.section-main-collection .facets-container')
          || document.querySelector('.template-search .facets-container');
        
        if (facetsContainer) {
          facetsContainer.classList.remove('extra-top');
        }
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
